import { createContext } from 'react';
import type { TreeNode } from 'src/utils/fileUtils';

export interface KnowledgeBaseContextValue {
  tree: TreeNode;
  setTree: (tree: TreeNode) => void;
  activeBranch: TreeNode;
  updateActiveBranch: (branch: TreeNode) => void;
  selectedItem: TreeNode;
  setSelectedItem: (item: TreeNode) => void;
  filteredValue: string;
  setFilteredValue: (value: string) => void;
  knowledgeBaseName: string;
  setKnowledgeBaseName: (name: string) => void;
  isEditPopupOpen: boolean;
  setIsEditPopupOpen: (open: boolean) => void;
  skipRefetchFiles: boolean;
  setSkipRefetchFiles: (skip: boolean) => void;
}

export const KnowledgeBaseContext = createContext<KnowledgeBaseContextValue | null>(null);
